// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentful-image-responsive[data-sizes="auto"]{width:100%;height:auto}
`, "",{"version":3,"sources":["webpack://./src/components/contentful/ImageResponsive.scss"],"names":[],"mappings":"AAAA,gDACE,UAAW,CACX,WAAY","sourcesContent":[".contentful-image-responsive[data-sizes=\"auto\"] {\n  width: 100%;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
